import styled from '@emotion/styled'

export const KPSEOAddonWrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  width: 50%;
`
export const StepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  // width: 100%;
  width: 200px;
  font-family: 'Open Sans', sans-serif;
  color: #231f20;

  .stepper-label {
    font-size: 14px;
    color: #231f20;
    font-weight: 500;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .stepper-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    // border-bottom: 1px solid #dcdcdc;
    border: 1px solid #dcdcdc;
    border-radius: 8px;
    padding: 6px 16px;
    // padding: 8px 12px;
    background: #fff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  &:focus-within .stepper-box {
    border-color: #5378fc;
    box-shadow: 0 0 0 2px rgba(83, 120, 252, 0.1);
  }

  .step-btn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #f2f6ff;
    color: #5378fc;
    font-size: 20px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
  }

  .step-btn:hover:not(:disabled) {
    background: #5378fc;
    color: #fff;
  }

  .step-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .step-value {
    min-width: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }

  .unit-label {
    font-size: 10px;
    color: #666;
    // margin-top: 2px;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
`
